// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import documentApi from '~/apis/document';
import {
  DELETE_DOCUMENT,
  EDIT_DOCUMENT,
  GET_DOCUMENT_LIST_BY_FOLDER,
  UPLOAD_DOCUMENT,
} from '~/utils/constants/actionType';
import {
  IDocumentByFolderParams,
  IEditDocumentParams,
  IUploadDocumentParams,
} from '~/utils/interface/document';

export const uploadDocument = createAsyncThunk(
  UPLOAD_DOCUMENT,
  async (payload: IUploadDocumentParams, { rejectWithValue }) => {
    try {
      const resp = await documentApi.uploadDocument(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDocumentListByFolder = createAsyncThunk(
  GET_DOCUMENT_LIST_BY_FOLDER,
  async (params: IDocumentByFolderParams, { rejectWithValue }) => {
    try {
      const resp = await documentApi.getDocumentByFolder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editDocument = createAsyncThunk(
  EDIT_DOCUMENT,
  async (payload: IEditDocumentParams, { rejectWithValue }) => {
    try {
      const resp = await documentApi.editDocument(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDocument = createAsyncThunk(
  DELETE_DOCUMENT,
  async (fileId: string, { rejectWithValue }) => {
    try {
      const resp = await documentApi.deleteDocument(fileId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
